import { render, staticRenderFns } from "./show-detail-tabbar.vue?vue&type=template&id=27581f7a&scoped=true&"
import script from "./show-detail-tabbar.vue?vue&type=script&lang=js&"
export * from "./show-detail-tabbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27581f7a",
  null
  
)

export default component.exports